module.exports = __webpack_public_path__ + "static/media/calendar-day.c28b15ce.svg";